import * as React from "react"
import { App } from "./app"
import { Assert } from "./PADebug"

///////////////   LoadingViewVm  ////////////////

export interface LoadingViewVm  {
    app: App,
    waitingFor: string
}

export interface LoadingStateVm {
}

// Showing a loading screen with animated dots while loading/merging in a selection of articles
export class LoadingView extends React.Component<LoadingViewVm, LoadingStateVm> {
    state: LoadingStateVm = {
    }

    // Sets the core's reference back to this view on initiation
    componentWillMount() {
        this.props.app.GetCore().ConnectLoadingView(this)
        this.DotStart()
    }
    
    constructor(props: LoadingViewVm) {
        super(props)
        this.m_dots = -1
    }

    render() {

        var message = "Loading"
        
        if (this.props.waitingFor == "project") {
            message = "Innhenter utvalg"
        }

        if (this.props.waitingFor == "buildPart") {
            message = "Innhenter bygningsdel"
        }

        var dots = ""

        for (var i = 0; i < this.m_dots; i++) {
            dots += "."
        }

        this.m_dots++

        if (this.m_dots > 4) {
            this.m_dots = 1
        }

        return <div style={{ marginLeft: "20px", marginTop: "20px"}}>{message}{dots}</div>
    }

    DotStart() {
        if (this.m_dots == -1) {
            this.m_dots = 1
            setTimeout(this.DotForward.bind(this), 450)
        }
    }

    DotForward() {
        if (this.props.app.state.DisplayMode == this.props.app.DMode.Loading) {
            setTimeout(this.DotForward.bind(this), 450)
            this.forceUpdate()
        }
    }

    m_dots : number
}



// WEBPACK FOOTER //
// ./client/view/LoadingView.tsx